import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/login2',
        method: 'post',
        data: data
    })
}
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}
export function updateUserProfile(data) {
   return request({
     url: '/system/user/profile',
     method: 'put',
     data: data
   })
 }
export function getInfo() {
    return request({
        url: '/getInfo2',
        method: 'get',
    })
}
export function getOrderPage(data) {
    return request({
        url: '/order/page',
        method: 'get',
        params: data
    })
}
export function pageClothingOrder(query) {
  return request({
    url: '/order/clothingPage',
    method: 'get',
    params: query
  })
}
export function pageClothingFactoryAssign(query) {
  return request({
    url: '/clothing/clothingFactoryAssign/page',
    method: 'get',
    params: query
  })
}
export function deptPageClothingFactoryAssign(query) {
  return request({
    url: '/clothing/clothingFactoryAssign/deptPage',
    method: 'get',
    params: query
  })
}

export function paperOrder(id) {
  return request({
    url: '/order/paper/' + id,
    method: 'post'
  })
}

export function transferOrder(id) {
  return request({
    url: '/order/transfer/' + id,
    method: 'post'
  })
}
export function getLaserList(data) {
    return request({
        url: '/laser/page',
        method: 'get',
        params: data
    })
}
export function getLaserInfo(data) {
    return request({
        url: '/laser/' + data,
        method: 'get'
    })
}
export function saveLaser(data) {
    return request({
        url: '/laser',
        method: 'post',
        data: data
    })
}
export function getClothingList(data) {
    return request({
        url: '/clothing/clothingProcess/page',
        method: 'get',
        params: data
    })
}
export function deptPageClothingProcess(query) {
  return request({
    url: '/clothing/clothingProcess/deptPage',
    method: 'get',
    params: query
  })
}

// 查询制衣车位加工明细列表
export function myPageClothingProcess(query) {
  return request({
    url: '/clothing/clothingProcess/myPage',
    method: 'get',
    params: query
  })
}
export function getClothingInfo(data) {
    return request({
        url: '/clothing/clothingFactoryAssign/queryProcessOrder/' + data,
        method: 'get'
    })
}
export function saveClothing(data) {
    return request({
        url: '/clothing/clothingProcess',
        method: 'post',
        data: data
    })
}
export function getClothingShipmentList(data) {
    return request({
        url: '/clothing/clothingShipment/page',
        method: 'get',
        params: data
    })
}
export function getMyClothingShipmentList(data) {
    return request({
        url: '/clothing/clothingShipment/myPage',
        method: 'get',
        params: data
    })
}
export function deptPageClothingShipment(query) {
  return request({
    url: '/clothing/clothingShipment/deptPage',
    method: 'get',
    params: query
  })
}
export function settlePageClothingShipment(query) {
  return request({
    url: '/clothing/clothingShipment/settlePage',
    method: 'get',
    params: query
  })
}
export function deptSettlePageClothingShipment(query) {
  return request({
    url: '/clothing/clothingShipment/deptSettlePage',
    method: 'get',
    params: query
  })
}

export function getClothingShipmentInfo(data) {
    return request({
        url: '/clothing/clothingFactoryAssign/queryShipmentOrder/' + data,
        method: 'get'
    })
}
export function saveClothingShipmentg(data) {
    return request({
        url: '/clothing/clothingShipment',
        method: 'post',
        data: data
    })
}
export function getOrderInfo(id) {
    return request({
        url: '/order/' + id,
        method: 'get',
    })
}
export function getStylePage(data) {
    return request({
        url: '/style/page',
        method: 'get',
        params: data
    })
}